module.exports = __webpack_public_path__ + "ath_game_web/img/Reddit_Logo.af3d6730.png";